export const UPLOAD_STATUS_WAITING = 0;
export const UPLOAD_STATUS_INITIALIZING = 1;
export const UPLOAD_STATUS_UPLOADING = 2;
export const UPLOAD_STATUS_UPLOADED = 3;
export const UPLOAD_STATUS_ERROR = 4;

/**
 * Maximum length of description
 *
 * @type {number}
 */
export const descriptionCharactersLimit = 4000;

/**
 * List of default attributes of episode.
 *
 * @type {object}
 */
export const defaultAttributes = {
    type: 'full',
};

// export const acceptedFileExtensions = ['audio/mpeg', 'audio/flac', 'audio/x-wav', '.m4a'];

/**
 * List of allowed MIME types of audio file.
 *
 * @type {string[]}
 */
export const audioFileAllowedMimeTypes = [
    'audio/mpeg',
    'audio/flac',
    'audio/x-flac',
    'audio/wav',
    'audio/x-wav',
    'audio/m4a',
    'audio/x-m4a',
];

/**
 * List of allowed extensions of audio file.
 *
 * @type {string[]}
 */
export const audioFileAllowedExtensions = [
    '.mp3',
    '.flac',
    '.wav',
    '.m4a',
];

/**
 * Maxiumum size (in bytes) of audio file.
 *
 * @type {number}
 */
export const audioFileMaxSize = 500000000;

/**
 * List of allowed MIME types of artwork file.
 *
 * @type {string[]}
 */
export const artworkFileAllowedMimeTypes = [
    'image/jpeg',
    'image/png',
];

/**
 * List of allowed extensions of artwork file.
 *
 * @type {string[]}
 */
export const artworkFileAllowedExtensions = [
    '.jpg',
    '.jpeg',
    '.png',
];

/**
 * List of allowed MIME types of audio file.
 *
 * @deprecated use {audioFileAllowedMimeTypes} instead.
 * @type {string[]}
 */
export const acceptedFileMimeTypes = audioFileAllowedMimeTypes;

/**
 * List of allowed extensions of audio file.
 *
 * @deprecated use {audioFileAllowedExtensions} instead.
 * @type {string[]}
 */
export const acceptedFileExtensions = audioFileAllowedExtensions;

export const episodeTypes = [
    {
        value: 'full',
        label: 'Full',
    },
    {
        value: 'trailer',
        label: 'Trailer',
    },
    {
        value: 'bonus',
        label: 'Bonus',
    },
];
